import { Stack } from "expo-router";

/** Invite route stack layout with all headers hidden. */
export default function InviteLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
